import {createSlice} from '@reduxjs/toolkit';

const barCodeResultSlice = createSlice({
  name: 'barCodeResult',
  initialState: {
    barCodeDetails: []
  },
  reducers: {
    setBarCoderesultList: (state, action) => {
      state.barCodeDetails = action.payload.barCodeDetails;
    },
  },
});
export const selectBarCode = (state) => state.barCodeResult;
export const {
  setBarCoderesultList,
} = barCodeResultSlice.actions;

export default barCodeResultSlice.reducer;
